import { Col, Container, Image, Row } from "react-bootstrap";
import { withTranslation } from "react-i18next";
import ikeHome from "../img/logos/ike-asistencia.svg";
import home2 from "../img/home/home2.png";

import "../styles/home.css";
import { Link } from "react-router-dom";
import { BsArrowRight } from "react-icons/bs";

function Home() {
  return (
    <div className="bg-body">
      <div className="bg-primary bg-img-home overflow-hidden position-relative">
        <Image src={ikeHome} className="position-ikeHome" />
        <h1 className="text-white pos-text-home">
          Mejoramos la vida de las personas
        </h1>
      </div>

      <Container className="m-5">
        <Row>
          <Col xs="12" md={{ span: 10, offset: 2 }}>
            <Row>
              <Col xs="12" md="6">
                <h5 className="color-b2">Asistencia digital</h5>
                <h1 className="text-dark">
                  Conoce nuestros nuevos servicios digitales
                </h1>
              </Col>
              <Col xs="12" md="6">
                <div className="card border-0">
                  <div className="row no-gutters">
                    <div className="col-md-4">
                      <Image src={home2} className="card-img" />
                    </div>
                    <div className="col-md-8">
                      <div className="card-body">
                        <h5 className="color-b2">Cuidando de tu salud</h5>
                        <h5 className="text-dark">Médico Online</h5>
                        <p className="text-muted font-size-09rem">
                          Cuidando tu salud con una red de expertos y servicios
                          especializados.
                        </p>
                        <Link
                          to="/admin"
                          className="text-uppercase font-weight-bold-600 link-home"
                        >
                          ingresa aquí <BsArrowRight className="wh-20" />
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default withTranslation()(Home);
